import React, { Fragment, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import style from "./Actions.module.sass";
import { callApi } from "../../../../helpers";

function Actions(props) {
  const {
    duplicateUrl,
    editUrl,
    tooltipActions,
    eyeUrl,
    onDeleteEnd,
    favourite,
    addFav,
    savePreferredUrl,
    removePreferredUrl,
    deleteUrl,
    onUpdateFav,
    addEdit,
    addDuplicate,
    addDelete,
    addEye,
    onDuplicateEnd,
    addCall,
    isPlanned,
  } = props;
  const btnEdit = useRef(null);
  const btnDelete = useRef(null);
  const btnDuplicate = useRef(null);
  const btnEye = useRef(null);
  const btnFav = useRef(null);
  const btnCamera = useRef(null);
  const [fav, setFav] = useState(favourite);

  useEffect(() => {
    setTooltips();
  }, []);

  useEffect(() => {
    setTooltips();
  }, [fav]);

  const setTooltips = () => {
    $(btnEdit.current).tooltip("dispose");
    $(btnCamera.current).tooltip("dispose");
    $(btnDelete.current).tooltip("dispose");
    $(btnDuplicate.current).tooltip("dispose");
    $(btnEye.current).tooltip("dispose");
    $(btnFav.current).tooltip("dispose");

    $(btnCamera.current).tooltip();
    $(btnEdit.current).tooltip();
    $(btnDelete.current).tooltip();
    $(btnDuplicate.current).tooltip();
    $(btnEye.current).tooltip();
    $(btnFav.current).tooltip();
  };

  const clickDelete = (e) => {
    e.stopPropagation();
    callApi(deleteUrl, "DELETE", "", (data) => {
      if (onDeleteEnd) onDeleteEnd(data);
    });
  };

  const clickOnDuplicate = (e) => {
    e.stopPropagation();
    callApi(duplicateUrl, "POST", "json", (data) => {
      if (onDuplicateEnd) onDuplicateEnd(data);
    });
  };

  const clickOnFav = (e) => {
    e.stopPropagation();
    let url = favourite && removePreferredUrl ? removePreferredUrl : savePreferredUrl
    let method = favourite && removePreferredUrl ? "DELETE" : "POST"
    callApi(url, method, "json", (data) => {
      setFav(!fav);
      if (onUpdateFav) {
        onUpdateFav();
      }
    });
  };

  const clickStartDelete = (e) => {
    e.stopPropagation();
    PersonalSequenceDeleter.toggleDelete(e.currentTarget.parentNode);
  };

  const onClickCancel = (e) => {
    e.stopPropagation();
    PersonalSequenceDeleter.toggleDelete(e.currentTarget.parentNode, false, isPlanned);
  };

  const renderFav = () => {
    return (
      <a
        data-ref-id={"fav"}
        className={`${style.copy} auto-tooltip move-out`}
        title={
          fav
            ? tooltipActions?.remove_to_sequence
            : tooltipActions?.add_to_sequence
        }
        onClick={clickOnFav}
        ref={btnFav}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="20"
          viewBox="0 0 21 20"
          width="21"
        >
          <path
            d="m13.9873684 0c.9726365 0 1.8642065.23293885 2.6747369.69882353.8105303.46588468 1.4473661 1.10646651 1.9105263 1.92176471.4631602.81529819.6947368 1.71211275.6947368 2.69047058 0 1.16471171-.3396457 2.3449352-1.0189473 3.54070589-.6021083 1.04047579-1.5592917 2.22846389-2.871579 3.56399999-.7873724.8075335-2.2308667 2.174108-4.3305263 4.0997647l-1.41263159 1.2811765-1.38947368-1.2345883c-2.06878228-1.8945977-3.51999584-3.2689369-4.35368421-4.1230588-1.31228727-1.3355361-2.26175146-2.52352419-2.84842106-3.56399998-.69474031-1.19577068-1.04210526-2.3837588-1.04210526-3.564 0-.97835783.23543624-1.87517239.70631579-2.69047058.47087955-.8152982 1.10771528-1.45588003 1.91052632-1.92176471.80281103-.46588468 1.69824067-.69882353 2.68631578-.69882353.81824971 0 1.61332948.18635108 2.38526316.55905882.77193369.37270775 1.42034826.86964396 1.94526316 1.49082353.52491489-.62117957 1.17332949-1.11811578 1.94526319-1.49082353.7719337-.37270774 1.5747326-.55905882 2.408421-.55905882z"
            fill={fav ? "#0083ff" : "transparent"}
            fillRule="evenodd"
            stroke="#f0f0f0"
            strokeWidth="2"
            transform="translate(1 1)"
          ></path>
        </svg>
      </a>
    );
  };

  const clickOnEdit = (e) => {
    e.stopPropagation();
    if (props.clickOnEdit) {
      props.clickOnEdit();
    }
  };

  const clickOnCamera = (e) => {
    e.stopPropagation();
    if (props.clickOnCamera) {
      props.clickOnCamera();
    }
  };

  const renderCall = () => {
    return (
      <a
        data-ref-id={"call"}
        className={`${style.pencil} auto-tooltip move-out`}
        title={tooltipActions?.call}
        ref={btnCamera}
        onClick={clickOnCamera}
      >
        <svg
          width="35px"
          height="35px"
          viewBox="0 0 35 35"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="ico-video"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <path
              d="M7.5,10 L18.5,10 C20.4329966,10 22,11.5670034 22,13.5 L22,22.5 C22,24.4329966 20.4329966,26 18.5,26 L7.5,26 C5.56700338,26 4,24.4329966 4,22.5 L4,13.5 C4,11.5670034 5.56700338,10 7.5,10 Z M7.5,12 C6.67157288,12 6,12.6715729 6,13.5 L6,22.5 C6,23.3284271 6.67157288,24 7.5,24 L18.5,24 C19.3284271,24 20,23.3284271 20,22.5 L20,13.5 C20,12.6715729 19.3284271,12 18.5,12 L7.5,12 Z M24.7032868,13.0356346 L28.0366201,12.100845 C29.2774167,11.7528799 30.5653626,12.4766629 30.9133277,13.7174595 C30.9708384,13.922535 31,14.1345191 31,14.347506 L31,21.6530716 C31,22.941736 29.9553311,23.9864049 28.6666667,23.9864049 C28.4536797,23.9864049 28.2416956,23.9572433 28.0366201,23.8997326 L24.7032868,22.964943 C23.6961258,22.682498 23,21.7642975 23,20.718282 L23,15.2822956 C23,14.2362801 23.6961258,13.3180796 24.7032868,13.0356346 Z M25.2433267,14.961344 C25.0994465,15.0016933 25,15.1328648 25,15.2822956 L25,20.718282 C25,20.8677128 25.0994465,20.9988843 25.2433267,21.0392336 L28.57666,21.9740231 C28.6059565,21.982239 28.63624,21.9864049 28.6666667,21.9864049 C28.8507616,21.9864049 29,21.8371665 29,21.6530716 L29,14.347506 C29,14.3170793 28.9958341,14.2867959 28.9876182,14.2574994 C28.9379089,14.0802427 28.7539167,13.9768452 28.57666,14.0265545 L25.2433267,14.961344 Z"
              id="Shape"
              fill="#F0F0F0"
              fillRule="nonzero"
            ></path>
          </g>
        </svg>
      </a>
    );
  };

  const renderEdit = () => {
    return (
      <a
        data-ref-id={"edit"}
        href={editUrl}
        className={`${style.pencil} auto-tooltip move-out`}
        title={tooltipActions?.edit}
        ref={btnEdit}
        onClick={clickOnEdit}
      >
        <svg
          height="20"
          viewBox="0 0 20 20"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m17.26 5.86-1.52 1.52-3.12-3.12 1.52-1.52c.1600008-.1600008.3566655-.24.59-.24s.4299992.0799992.59.24l1.94 1.94c.1600008.1600008.24.3566655.24.59s-.0799992.4299992-.24.59zm-14.76 8.52 9.22-9.22 3.12 3.12-9.22 9.22h-3.12z"
            fill="#f0f0f0"
          />
        </svg>
      </a>
    );
  };

  const renderEye = () => {
    return (
      <a
        data-ref-id={"eye"}
        href={eyeUrl}
        className={`auto-tooltip move-out`}
        title={tooltipActions?.show}
        ref={btnEye}
        onClick={(e) => e.stopPropagation()}
      >
        <svg
          height="33"
          viewBox="0 0 33 33"
          width="33"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd" transform="translate(1 1)">
            <path
              d="m16.0527344 12.7675781c.9375047 0 1.7343717.3310514 2.390625.9931641s.984375 1.45605.984375 2.3818359c0 .9375047-.3281217 1.7343717-.984375 2.390625s-1.4531203.984375-2.390625.984375c-.9257859 0-1.7197233-.3281217-2.381836-.984375-.6621126-.6562533-.993164-1.4531203-.993164-2.390625 0-.9257859.3310514-1.7197232.993164-2.3818359.6621127-.6621127 1.4560501-.9931641 2.381836-.9931641zm0 5.625c.6210968 0 1.1484353-.222654 1.5820312-.6679687.4335959-.4453148.6503906-.9785125.6503906-1.5996094s-.2197243-1.151365-.6591796-1.5908203c-.4394554-.4394553-.9697235-.6591797-1.5908204-.6591797-.6210968 0-1.1513649.2197244-1.5908203.6591797-.4394553.4394553-.6591797.9697234-.6591797 1.5908203s.2255837 1.1542946.6767579 1.5996094c.4511741.4453147.9814422.6679687 1.5908203.6679687zm8.9472656-2.390625c0 .0234376.0029297.0468749.0087891.0703125s.008789.0468749.008789.0703125-.0029296.0498046-.008789.0791016-.0087891.0556639-.0087891.0791015c-.0117188.0117189-.0175781.0234375-.0175781.0351563v.0527344l-.0175781.0175781v.0263672c0 .0058594-.0058594.0146484-.0175782.0263672-.3984395.9375047-.9140593 1.7695276-1.546875 2.4960937-.6328156.7265662-1.3417929 1.3388647-2.1269531 1.8369141s-1.6259721.8789049-2.5224609 1.1425781c-.8964889.2636732-1.8134719.3955078-2.7509766.3955078s-1.8544877-.1318346-2.7509766-.3955078c-.8964888-.2636732-1.7373007-.6445287-2.5224609-1.1425781-.78516018-.4980494-1.49413746-1.1103479-2.12695312-1.8369141-.63281567-.7265661-1.15429483-1.558589-1.56445313-2.4960937v-.0527344l-.00878906-.0087891c-.00585941-.0058594-.00878907-.0146483-.00878907-.0263671v-.0351563c0-.0117188-.00585931-.0292968-.01757812-.0527344 0-.0234376-.00292966-.0468749-.00878906-.0703125-.00585941-.0234376-.00878906-.0468749-.00878906-.0703125s.00292965-.0498045.00878906-.0791015c.0058594-.0292971.00878906-.055664.00878906-.0791016.01171881-.0117188.01757812-.0234374.01757812-.0351562v-.0527344l.01757813-.0175782v-.0527343c.4101583-.9375047.93456712-1.7724573 1.57324219-2.5048828.63867507-.7324256 1.35058201-1.3505835 2.13574216-1.8544922.7851602-.5039088 1.6289018-.887694 2.53125-1.1513672.9023483-.2636732 1.822261-.39550782 2.7597656-.39550782.9375047 0 1.8544878.13183462 2.7509766.39550782.8964889.2636732 1.7314415.6474584 2.5048828 1.1513672.7734414.5039087 1.4765594 1.1220666 2.109375 1.8544922.6328157.7324255 1.1484355 1.5673781 1.546875 2.5048828.0117188.0117188.0175782.0205078.0175782.0263672v.0263671l.008789.0087891c.0058594.0058594.0087891.0146484.0087891.0263672v.0351563c0 .0117188.0058593.0292967.0175781.0527343zm-9 5.203125c.796879 0 1.584957-.1054677 2.3642578-.3164062.7793008-.2109386 1.5117153-.5273417 2.1972656-.949218s1.3124972-.9492156 1.8808594-1.5820312c.5683622-.6328157 1.0400372-1.3710896 1.4150391-2.2148438-.37500189-.8437542-.8437472-1.5820281-1.40625-2.2148437-.5625028-.6328157-1.18652-1.1630838-1.8720703-1.5908203-.6855503-.4277366-1.4150352-.749999-2.1884766-.9667969-.7734414-.216798-1.5585898-.3251953-2.3554688-.3251953-.7968789 0-1.584957.1083973-2.3642578.3251953-.7793007.2167979-1.5146449.5390603-2.2060546.9667969-.6914098.4277365-1.3242159.9580046-1.89843755 1.5908203-.57422162.6328156-1.04882625 1.3710895-1.42382813 2.2148437.37500188.8437542.84960651 1.5820281 1.42382813 2.2148438.57422165.6328156 1.20409815 1.1601541 1.88964845 1.5820312s1.4150352.7382802 2.1884765.9492188c.7734414.2109385 1.5585898.3164062 2.3554688.3164062z"
              fill="#f0f0f0"
            />
          </g>
        </svg>
      </a>
    );
  };

  const renderDuplicate = () => {
    return (
      <a
        data-ref-id={"duplicate"}
        className={`${style.copy} auto-tooltip move-out`}
        title={tooltipActions?.duplicate}
        onClick={clickOnDuplicate}
        ref={btnDuplicate}
      >
        <svg
          height="25"
          viewBox="0 0 25 25"
          width="25"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="#f0f0f0"
            strokeWidth="2"
            transform="translate(2 6)"
          >
            <rect height="10" rx="1" width="17" y="4" />
            <path
              d="m21 11h-11.7c-.71797017 0-1.3-.4104056-1.3-.9166667v-10.0833333"
              transform="matrix(-1 0 0 -1 29 11)"
            />
          </g>
        </svg>
      </a>
    );
  };

  const renderDelete = () => {
    return (
      <span className={`${style.deleteButtons}`}>
        <span
          className={`${style.cross} auto-tooltip cross`}
          title={tooltipActions?.delete}
          onClick={clickStartDelete}
          ref={btnDelete}
        >
          <svg
            height="22"
            viewBox="0 0 22 22"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              fill="none"
              stroke="#f0f0f0"
              strokeWidth="2"
              transform="matrix(.70710678 .70710678 -.70710678 .70710678 11 -3.142136)"
            >
              <circle cx="10" cy="10" r="10" />
              <g strokeLinecap="round">
                <path d="m10 5v9.3333333" />
                <path d="m14.6666667 9.66666667h-9.33333337" />
              </g>
            </g>
          </svg>
        </span>
        <span
          className={`${style.cancel} d-none cursor-link cancel`}
          onClick={onClickCancel}
        >
          <svg
            height="25"
            viewBox="0 0 25 25"
            width="25"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              fill="none"
              stroke="#f0f0f0"
              strokeWidth="2"
              transform="translate(-2 -3)"
            >
              <circle
                cx="14.142136"
                cy="15"
                r="10"
                transform="matrix(.70710678 .70710678 -.70710678 .70710678 14.748737 -5.606602)"
              />
              <g
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="matrix(.70710678 .70710678 -.70710678 .70710678 12.622366 6.514719)"
              >
                <path
                  d="m11.4195706 4.49211768h-8.4081648"
                  transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.852507 6.499694)"
                />
                <path
                  d="m7.48009335 2.2718054-4.60844615 4.60844614 4.60844615 4.48806996"
                  transform="matrix(.70710678 -.70710678 .70710678 .70710678 -3.306536 5.657443)"
                />
              </g>
            </g>
          </svg>
        </span>
        <span
          onClick={clickDelete}
          className={`${style.delete} d-none cursor-link delete`}
        >
          {tooltipActions?.delete}
        </span>
      </span>
    );
  };

  return (
    <Fragment>
      {addCall && renderCall()}
      {addEdit && renderEdit()}
      {addEye && renderEye()}
      {addDuplicate && renderDuplicate()}
      {addFav && renderFav()}
      {addDelete && renderDelete()}
    </Fragment>
  );
}

Actions.propTypes = {};

Actions.defaultProps = {
  tooltipActions: {
    edit: "edit",
    duplicate: "duplicate",
    delete: "delete",
  },
  addFav: false,
  addEdit: true,
  addDuplicate: true,
  addDelete: true,
  addEye: false,
  favourite: false,
  addCall: false,
};

export default Actions;
